export const FOR_NAME = 'forName';
export const FOR_ID = 'forId';
